import React from 'react';
import { Route, Switch } from "react-router-dom";
import TableManagementEquips from './Tables/TableManagementEquips';
import TableManagementServices from './Tables/TableManagementServices';
import TableCompanies from './Tables/TableCompanies';
import MyAccount from '../User/MyAccount/MyAccount';
import Arquivos from '../../components/Arquivos/Arquivos';
import ParamPlaces from './Tables/ParamPlaces';
import ParamMaps from './Tables/ParamMaps';
import ParamEquipPlaces from './Tables/ParamEquipPlaces';
import ParamAreas from './Tables/ParamAreas';
import ParamGroups from './Tables/ParamGroups';
import ParamTiposServicos from './Tables/ParamTiposServicos';
import ParamFrequency from './Tables/ParamFrequency';
import ParamEquipmentModels from './Tables/ParamEquipmentModels';
import ParamStatusVerificationItems from './Tables/ParamStatusVerificationItems';
import FormEquipments from './Forms/FormEquipments/FormEquipments';
import FormEquipmentServices from './Forms/FormEquipments/FormEquipmentsServices';
import FormEquipmentsActions from './Forms/FormEquipments/FormEquipmentsActions';
import FormEquipmentsLogs from './Forms/FormEquipments/FormEquipmentsLogs';
import FormEquipmentsAttachmentFiles from './Forms/FormEquipments/FormEquipmentsAttachmentFiles';
import FormServices from './Forms/FormServices';
import FormParamFrequency from './Forms/FormParamFrequency';
import FormParamEquipmentModels from './Forms/FormParamEquipmentModels';
import FormCompany from './Forms/FormCompany';
import TableUsers from './Tables/ParamUsers';
import FormParamUsers from './Forms/FormParamUsers';
import FormParamCreateUsers from './Forms/FormParamCreateUsers';
import TableManagementAppBackups from './Tables/TableManagementAppBackups';
import TableDataExport from './Tables/TableDataExport';
import TableLogs from './Tables/TableLogs';
import LogsEquipment from './Logs/LogsEquipment';
import FormEquipmentsMaintenance from './Forms/FormEquipments/FormEquipmentsMaintenance';
import FormHandleMaintenance from './Forms/FormHandleMaintenance';
import Reports from './Reports/Reports';
import FormEquipmentsFinance from './Forms/FormEquipments/FormEquipmentsFinance';
import { MassiveImport } from './MassiveImport';
import EditService from '../Services/EditService/EditService';
import CreateService from '../Services/CreateService/CreateService';
import FormParamNotificationWebhook from './Forms/FormParamNotificationWebhook';
import Settings from '../Settings/Settings';
import TableServiceDrafts from './Tables/TableServiceDrafts';

const Routes = () => (
  <Switch>
    <Route path="/minha-conta" component={MyAccount} />
    
    <Route path="/arquivo-apoio" component={Arquivos} />

    <Route path="/admin-gestao-equip" component={TableManagementEquips} />
    <Route path="/admin-gestao-servicos" component={TableManagementServices} />
    <Route path="/admin-empresas" component={TableCompanies} />
    <Route path="/admin-backups-app" component={TableManagementAppBackups} />
    <Route path="/data-export" component={TableDataExport} />
    <Route path="/service-drafts" component={TableServiceDrafts} />
    <Route path="/admin-reports" component={Reports}/>
    <Route path="/admin-places" component={ParamPlaces} />
    <Route path="/admin-maps" component={ParamMaps} />
    <Route path="/admin-equip-places/:id" component={ParamEquipPlaces} />
    <Route path="/admin-areas" component={ParamAreas} />
    <Route path="/admin-groups" component={ParamGroups} />
    <Route path="/admin-equipments" component={ParamEquipmentModels} />
    <Route path="/admin-usuarios" component={TableUsers} />
    <Route path="/admin-notification-webhook" component={FormParamNotificationWebhook} />

    <Route path="/admin-period" component={ParamFrequency} />
    <Route path="/admin-tipos-servicos" component={ParamTiposServicos} />
    <Route path="/admin-status-item-verificacao" component={ParamStatusVerificationItems} />

    <Route path="/form-equip/:id/:back_page/:back_page_id?" component={FormEquipments} />
    <Route path="/form-equip-services/:id/:back_page/:back_page_id?" component={FormEquipmentServices} />
    <Route path="/form-equip-actions/:id/:back_page/:back_page_id?" component={FormEquipmentsActions} />
    <Route path="/form-equip-maintenance/:id/:back_page/:back_page_id?" component={FormEquipmentsMaintenance} />
    <Route path="/form-equip-logs/:id/:back_page/:back_page_id?" component={FormEquipmentsLogs} />
    <Route path="/form-equip-logs-db/:id/:back_page/:back_page_id?" component={LogsEquipment} />
    <Route path="/form-equip-attachmentFiles/:id/:back_page/:back_page_id?" component={FormEquipmentsAttachmentFiles} />
    <Route path="/form-equip-finance/:id/:back_page/:back_page_id?" component={FormEquipmentsFinance} />
    <Route path="/form-equipments-param/:id" component={FormParamEquipmentModels} />
    <Route path="/form-period/:id" component={FormParamFrequency} />
    <Route path="/form-empresa/:id" component={FormCompany} />
    <Route path="/form-user/:id" component={FormParamUsers} />
    <Route path="/form-user-new" component={FormParamCreateUsers} />
    <Route path="/form-maintenance/:id?/:equip_id?" component={FormHandleMaintenance} />
    <Route path="/form-new-service/:step" component={CreateService} />
    <Route path="/form-edit-service/:id/" component={EditService} />

    <Route path="/admin-logs" component={TableLogs} />

    <Route path="/massive-import/:type" component={MassiveImport} />

    <Route path="/settings" component={Settings} />
  </Switch>
);

export default Routes;
